import { Stack } from '@mui/material';
import React from 'react';

import { CheckIcon } from '@/shared/assets/icons/check-icon';
import {
  MainContent,
  SelectablePlaceholder,
  StyledMenuItem,
} from '@/shared/components/ui/menu-item/menu-item.styled';
import { TMenuItemProps } from '@/shared/components/ui/menu-item/menu-item.types';
import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';
import { useHasPermission } from '@/shared/features/permissions/hooks/use-permission-check/use-permission-check';

export const MenuItem: React.FC<TMenuItemProps> = ({
  variant,
  icon,
  selected,
  additionalInfo,
  children,
  tooltip,
  tooltipProps,
  permission,
  ...rest
}) => {
  const isSelectable = typeof selected === 'boolean';
  const hasPermission = useHasPermission(permission);

  if (!hasPermission) {
    return null;
  }

  return (
    <Tooltip title={tooltip} {...tooltipProps} wrapper="fullWidth">
      <StyledMenuItem $variant={variant} {...rest}>
        <MainContent $variant={variant}>
          {icon}
          {children}
        </MainContent>
        {(additionalInfo || isSelectable) && (
          <Stack direction="row" alignItems="center" gap="0.5rem">
            {additionalInfo}
            {isSelectable &&
              (selected ? (
                <CheckIcon variant="primary" />
              ) : (
                <SelectablePlaceholder />
              ))}
          </Stack>
        )}
      </StyledMenuItem>
    </Tooltip>
  );
};
